(() => {
  /* BEZELOR side rail: the tucked-away tab can be swiped left to pull the rail out (a tap still works).
     The rail follows the finger and springs back if the swipe is too short. */
  const start = () => {
    const nav = document.querySelector('.bezelor-pdp-flow nav.bezelor-pdp-tabs');
    if (!nav || nav.dataset.bzSwipe) return;
    nav.dataset.bzSwipe = 'true';
    let x0 = 0;
    let y0 = 0;
    let dx = 0;
    let active = false;
    let decided = false;
    nav.addEventListener('touchstart', (event) => {
      if (!nav.classList.contains('bz-rail') || !nav.classList.contains('is-idle') || event.touches.length !== 1) return;
      x0 = event.touches[0].clientX;
      y0 = event.touches[0].clientY;
      dx = 0;
      active = true;
      decided = false;
    }, { passive: true });
    nav.addEventListener('touchmove', (event) => {
      if (!active) return;
      const mx = event.touches[0].clientX - x0;
      const my = event.touches[0].clientY - y0;
      if (!decided) {
        if (Math.abs(mx) < 6 && Math.abs(my) < 6) return;
        decided = true;
        if (Math.abs(my) > Math.abs(mx) || mx > 0) {
          active = false;
          return;
        }
        nav.style.transition = 'none';
      }
      event.preventDefault();
      dx = Math.max(-80, Math.min(0, mx));
      nav.style.translate = 'calc(100% + 10px + ' + dx + 'px) 0';
    }, { passive: false });
    const end = () => {
      if (!active) return;
      active = false;
      nav.style.transition = '';
      nav.style.translate = '';
      if (decided && dx < -24) nav.click(); /* the rail's own handler brings it out when tucked away */
    };
    nav.addEventListener('touchend', end);
    nav.addEventListener('touchcancel', end);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setTimeout(start, 50));
  else setTimeout(start, 50);
})();

(() => {
  /* Desktop product page: the watch perks (under the photo) and the BEZELOR promise box (middle column)
     start at the same height. Whichever sits higher moves down to meet the other, so it stays aligned
     however much the middle column holds. Recalculated whenever either column changes size. */
  const wide = window.matchMedia('(min-width: 980px)');
  let frame = null;
  const isStuck = (el) => {
    for (let node = el; node && node !== document.body; node = node.parentElement) {
      if (getComputedStyle(node).position === 'sticky') return window.scrollY > 40;
    }
    return false;
  };
  const align = () => {
    frame = null;
    const root = document.querySelector("product-info[id^='MainProduct-']");
    if (!root) return;
    const promise = root.querySelector('.bz-desktop-trust');
    const perks = [...root.querySelectorAll('.bz-perks')].find((el) => el.offsetParent && !el.contains(promise) && !promise?.contains(el));
    if (!perks || !promise) return;
    /* A sticky column measures from where it is stuck, so keep the last alignment while scrolled */
    if (isStuck(perks) || isStuck(promise)) return;
    perks.style.removeProperty('margin-top');
    promise.style.removeProperty('margin-top');
    if (!wide.matches || !promise.offsetParent) return;
    const gap = Math.round(promise.getBoundingClientRect().top - perks.getBoundingClientRect().top);
    if (Math.abs(gap) < 2) return;
    const higher = gap > 0 ? perks : promise;
    const base = parseFloat(getComputedStyle(higher).marginTop) || 0;
    higher.style.setProperty('margin-top', base + Math.abs(gap) + 'px', 'important');
  };
  const queue = () => {
    if (!frame) frame = requestAnimationFrame(align);
  };
  const start = () => {
    const root = document.querySelector("product-info[id^='MainProduct-']");
    if (!root) return;
    queue();
    window.addEventListener('load', queue);
    window.addEventListener('resize', queue, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(queue);
    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(queue);
      root.querySelectorAll('.product__media-wrapper, .product__info-container').forEach((col) => ro.observe(col));
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
